import { render, staticRenderFns } from "./CreateProgress.vue?vue&type=template&id=3356536b"
import script from "./CreateProgress.vue?vue&type=script&lang=ts"
export * from "./CreateProgress.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports